export default "__VITE_ASSET__BCnF0FUL__"